import { render, staticRenderFns } from "./ShopDetails.vue?vue&type=template&id=77370f70&scoped=true"
import script from "./ShopDetails.vue?vue&type=script&lang=js"
export * from "./ShopDetails.vue?vue&type=script&lang=js"
import style0 from "./ShopDetails.vue?vue&type=style&index=0&id=77370f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77370f70",
  null
  
)

export default component.exports